<!-- 选项卡模块 -->
<template>
  <div class="tabs-mo-kuai">
    <div class="tab-main">
      <div class="tab-list">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="{ 'tab-item': true, active: item.val === activeIndex }"
          @click="tabToggle(index)"
        >
          {{ item.key }}
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      activeIndex: '0'
    }
  },
  watch: {
    index(val) {
      this.activeIndex = JSON.stringify(val)
    }
  },
  methods: {
    // tab切换
    tabToggle(index) {
      this.activeIndex = JSON.stringify(index)
      this.$emit('update:index', Number(this.activeIndex))
    }
  }
}
</script>

<style lang="less" scoped>
.tabs-mo-kuai {
  .tab-main {
    display: flex;
    align-items: center;
    width: 100%;
    height: 30px;
    background: @colorGrayF;
    border-bottom: 1px solid @colorGrayD;
    .tab-list {
      font-size: 12px;
      display: flex;
      .tab-item {
        display: flex;
        align-items: center;
        height: 30px;
        padding: 0 10px;
        border-right: 1px solid @colorGrayD;
        border-bottom: 1px solid @colorGrayD;
        cursor: pointer;

        &.active {
          cursor: inherit;
          background: @colorWhite;
          border-bottom-color: @colorWhite;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
